module.exports = __webpack_public_path__ + "static/media/mc_front_empty.0241d64c.svg";